import { render } from "./PostCategoryList.vue?vue&type=template&id=43a69c3e"
import script from "./PostCategoryList.vue?vue&type=script&lang=js"
export * from "./PostCategoryList.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__